import { render, staticRenderFns } from "./council_figure.vue?vue&type=template&id=7e8bc369&"
import script from "./council_figure.vue?vue&type=script&lang=js&"
export * from "./council_figure.vue?vue&type=script&lang=js&"
import style0 from "./council_figure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports